import * as angular from "angular";
import {IController} from "angular";

export class labelSelectCtrl implements IController {

  notes: any;
  canDeleteNote: boolean;
  onDeleteNote: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
  };
}

angular
  .module('bringoz.admin.commons')
  .component('bringozNotesList', {
    bindings: {
      notes: '<',
      canDeleteNote: '<?',
      onDeleteNote: '&'
    },
    template: require('./bringoz-notes-list.html').default,
    controller: labelSelectCtrl
  });
